
export function getColorText (color) {
  let colorRgb = hexToRgb(color)
  // http://www.w3.org/TR/AERT#color-contrast
  var o = Math.round(((colorRgb.r * 299) + (colorRgb.g * 587) + (colorRgb.b * 114)) / 1000)

  if (o > 125) {
    return '#424242'
  } else {
    return '#FFFFFF'
  }
}

function hexToRgb (hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null
}

export function isInViewport (elem) {
  var bounding = elem.getBoundingClientRect()
  return (
    bounding.top >= 0 &&
    bounding.left >= 0 &&
    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
  )
}

// agrupar array por id de propiedad
export function groupById (array, prop) {
  return array.reduce(function (groups, item) {
    const val = item[prop].id
    groups[val] = groups[val] || []
    groups[val].push(item)
    return groups
  }, {})
}

// UBICACION
// si es posible usamos la del dispositivo actual
// si no es posible intentamos usar la del dispositivo de vinculación
export function setLocation (payload) {
  localStorage.setItem('lat', payload.lat)
  localStorage.setItem('lon', payload.lon)
}

export function getLocation (state) {
  // let lat = localStorage.getItem('lat')
  // let lon = localStorage.getItem('lon')

  // if (lat && lon && lat !== 'undefined' && lon !== 'undefined') {
  //   return {
  //     'lat': lat,
  //     'lon': lon
  //   }
  // } else {
  //   return null
  // }
  return {
    'lat': 0,
    'lon': 0
  }
}



// WEBPACK FOOTER //
// ./src/utils/helper-functions.js